import { APP_SPLASH_MIN_VERSION_CODE } from './appSplash';

/**
 * Set on <html> inside the new Android app (version_code ≥ 9100), which gets the floating pill
 * bottom nav. It is decided by an inline <head> script before first paint, so the server-rendered
 * (old) bar never flashes before hydration; client navigations keep the same <html>.
 */
export const NEW_APP_SHELL_ATTR = 'data-floating-bottom-nav';

// Dev-only `localStorage['debug:new-app-shell'] = '1'` previews it in a normal browser tab;
// `?new_app_shell=1` / `=0` in the address turns that on / off.
const DEV_PREVIEW = process.env.NODE_ENV !== 'production';

/** Same rule as isPWA() + apphome.tsx's stored `app:version_code`. */
export const NEW_APP_SHELL_INLINE_SCRIPT = `(function(){try{var ls=window.localStorage;if(${DEV_PREVIEW}){var q=/[?&]new_app_shell=([01])/.exec(location.search);if(q){q[1]==='1'?ls.setItem('debug:new-app-shell','1'):ls.removeItem('debug:new-app-shell')}}if(${DEV_PREVIEW}&&ls.getItem('debug:new-app-shell')==='1'){document.documentElement.setAttribute('${NEW_APP_SHELL_ATTR}','');return}var r=document.referrer;if(!(window.matchMedia('(display-mode: standalone)').matches||r.indexOf('android-app://')>-1||r.indexOf('ios-app://')>-1))return;var m=/[?&]version_code=(\\d+)/.exec(location.search);var v=+(m?m[1]:ls.getItem('app:version_code'));if(v>=${APP_SPLASH_MIN_VERSION_CODE})document.documentElement.setAttribute('${NEW_APP_SHELL_ATTR}','')}catch(e){}})();`;

export const isNewAppShell = () =>
  typeof document !== 'undefined' && document.documentElement.hasAttribute(NEW_APP_SHELL_ATTR);

/**
 * True inside the new Android app only (never on the website, in a browser tab or in an older app build).
 * Reads the attribute the inline head script above has already set, so it is valid from the first effect on.
 */
export const isNewApp = () => typeof document !== 'undefined' && document.documentElement.hasAttribute(NEW_APP_SHELL_ATTR);
